<template>
  <div>
    <div class="right_table" :class="{showLeft:!showLeft}">
      <a-icon type="left-circle" class="close" @click="showLeft = false" v-if="showLeft"/>
      <a-icon type="right-circle" class="close" @click="showLeft = true" v-else/>

      <x-grid
          :id="'formList'"
          :rowId="rowId"
          :pager-config="pagerConfig"
          :form-config="formConfig"
          :url="url"
          :columns="columns"

          :checkbox-config="checkboxConfig"
          :toolbar-config="toolbarConfig"
          :print-config="printConfig"
          :export-config="exportConfig"
          ref="grid"
          :cellClick="chooseRow"
          :cellDbClick="updateRow"
          @toolbar-addData="addRow"
      >
<!--        :otherParams="{'planMold':1,receiveDeptId}"-->

<!--        <template v-slot:[toolbarConfig.templatelSlots]>-->
<!--          <div class="status_box">-->
<!--            <span class="status_item" :class="navSwitch == 0?'active':''" @click="changeNav(0)">厂家</span>-->
<!--            <span class="status_item" :class="navSwitch == 1?'active':''" @click="changeNav(1)">经理部</span>-->
<!--            <span class="status_item" :class="navSwitch == 2?'active':''" @click="changeNav(2)">经销商</span>-->
<!--            &lt;!&ndash;          <span class="status_item" :class="navSwitch == 3?'active':''" @click="changeNav(3)">销售顾问</span>&ndash;&gt;-->
<!--            <div class="btns_box">-->
<!--              <vxe-button @click="addRow" v-if="navSwitch == 0">新增</vxe-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->

        <template v-slot:operate="{row}">
            <vxe-button size="mini" v-auth="`VIEW`"  status="primary" @click="qurryDeta(row)" >查看</vxe-button>
        </template>
      </x-grid>

      <!-- 详情页 -->
      <formModal
          title="活动计划详情"
          centered
          :closable="true"
          :footer="null"
          :maskClosable="false"
          :visible="editModalVisible"
          :width="1200"
      >
        <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
        <detailForm
            :rowId="editRowId"
            :index="index"
            :navFlag="navFlag"
            :strainIdId="strainIdId"
            :navSwitch="navSwitch"
            :disabledDetail="disabledDetail"
            v-if="editModalVisible"
            ref="detailForm"
            @cancelled="closeEdit()"
            @saved="closeEdit(true)"
        >
        </detailForm>
      </formModal>
      <!--  查看数据 -->
      <a-modal
          title="查看完成情况"
          centered
          :footer="null"
          :maskClosable="true"
          v-model="showTransferPop"
          :width="1200"
          :closable="true"
      >
        <!--      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数-->
        <finishResult
            :transferIdArr="transferIdArr"
            v-if="showTransferPop"
            :planId="issuedId"
            :navSwitch="navSwitch"
            :deptOrUser="deptOrUser"
            ref="finishResult"
            @close="closeTransferPop"
        >
        </finishResult>
      </a-modal>
      <!--  查看数据 -->
      <a-modal
          title="查看完成情况"
          centered
          :footer="null"
          :maskClosable="true"
          v-model="dealerProp"
          :width="1200"
          :closable="true"
      >
        <!--      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数-->
        <dealerFinishResult
            :transferIdArr="transferIdArr"
            v-if="dealerProp"
            :planId="issuedId"
            :navSwitch="navSwitch"
            :deptOrUser="deptOrUser"
            ref="dealerFinishResult"
            @close="closeTransferPop"
        >
        </dealerFinishResult>
      </a-modal>
    </div>
  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import {GridMixin} from "@/utils/GridMixin";
import {formatter as fmt} from "@/utils/ebase-formatter";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";
import detailForm from "./visitRecordDetail";
import {dataApi} from "@/services/bigCustomer/visitRecord";
import {XEUtils} from "@/utils/common/FormBase";
//新增的结束
console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除
const fac = XGrid.factory;
//列表接口
const url = api.visit.VISIT;
//主键
const rowId = "id";
//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("visitTypeName", "拜访类型", 90),
  fac.makeColumn("provinceName", "省份", 100),
  fac.makeColumn("cityName", "城市", 100),
  fac.makeColumn("visitSourceName", "客户来源", 100),
  fac.makeColumn("customerName", "客户名称", 100),
  fac.makeColumn("name", "联系姓名", 100),
  fac.makeColumn("post", "岗位", 80),
  fac.makeColumn("contactPhone", "联系方式", 100),
  fac.makeColumn("segmentedIndustryName", "细分行业", 100),
  fac.makeColumn("strainName", "品系", 100),
  fac.makeColumn("intentionalName", "是否有意向", 100),
  fac.makeColumn("intentionCarConfig", "车型配置", 100),
  fac.makeColumn("intentionSeriesStrainsName", "需求品系", 100),
  fac.makeColumn("demandCount", "客户需求总数量", 100),
  fac.makeColumn("estimatedPurchaseDate", "预计购车日期", 100),
  fac.makeColumn("currentVehicleInfo", "现在在用车辆", 100),
  fac.makeColumn("custVehCount", "客户车辆保有量", 100),
  fac.makeColumn("customerLevelName", "客户等级", 100),

  fac.makeColumn("deptName", "拜访人部门", 100),
  fac.makeColumn("regionName", "拜访人上级部门", 120),
  fac.makeColumn("userName", "拜访人名称", 100),
  fac.makeColumn("createDate", "拜访时间", 100),
  fac.makeColumn("locationAddress", "位置定位", 140),
  fac.makeColumn("visitContentRecord", "拜访记录", 100),
  fac.makeColumn("serviceFeedBack", "服务/质量问题反馈", 140),
  fac.makeColumn("support", "需总部支持项", 120),
  fac.makeColumn("isAccompanyLeader", "是否有随行领导", 100),
  fac.makeColumn("accompanyLeader", "随行领导", 100),
  fac.makeColumn("vehicleQuantityInfo", "乘龙及竞品车辆数量", 150),
  fac.makeColumn("hasOwnRepairShopName", "是否有自建修理厂/工", 140),
  fac.makeColumn("nearestGuaranteeStation", "我司最近保障站", 130),
  fac.makeColumn("stationDistance", "与最近保障站距离(km)", 140),
  fac.makeColumn("cargoTypeAndLoad", "货物类型及载重", 130),
  fac.makeColumn("isRegisteredVplusName", "是否注册乘龙V+车联网", 140),
  fac.makeColumn("unregisteredVplusReason", "未注册V+原因", 130),
  fac.makeColumn("operationRoute", "运营路线", 130),
  fac.makeColumn("energyConsumptionComparison", "能耗对比情况", 140),
  // fac.makeColumn("photos", "现场图片（含给客户解读运营报告图）", 150),
  fac.makeColumn({
    title: "操作",
    field: 'operate',
    slots: {
      default: 'default'
    },
    align: 'center',
    width: 200,
    fixed: 'right'
  }),
];
// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {
    field: "visit_type",
    title: "拜访类型",
    type: "select",
    options: [
      { label: "全部", value: "" },
      { label: "销售", value: "1" },
      { label: "服务", value: "2" }
    ]
  },
  {
    field: "customer_name",
    title: "客户名称",
  },
  {
    field: "name",
    title: "联系人姓名",
  },
  {
    field: "contact_phone",
    title: "联系方式",
  },
  {
    field: "user_name",
    title: "拜访人姓名",
  },
  // {
  //   field: "dept_name",
  //   title: "部门名称",
  // },
  // {
  //   field: "intentional_name",
  //   title: "是否有意向",
  //   type: "select",
  //   options: ["有意向","没意向"]
  // },
  {
    field: "create_date",
    title: "拜访时间",
    type: 'dateRange',
  },
  {
    field: "deptId",
    'customSearch': true,
    title: "部门",
    type: "select",
    options: [],
  },
  // {
  //   field: "dealerId",
  //   // 'customSearch': true,
  //   title: "经销商",
  //   type: "search-select",
  //   options: [],
  //   placeholder:'请选择经销商',
  //
  // },
]);
//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: true,
  import: false,
  delData: false,
  addData: false,
  templatelSlots: "toolbarBtns",
});

async function loadBaseData() {
  localStorage.setItem('showUserName', 0);
  let region = {
    // isRegion: 1,
    // isDealer: 0
  }
  // let dealer = {
  //   isRegion: 0,
  //   isDealer: 1
  // }
  this.regionOptions = await dataApi.selection(region);//经理部
  // this.dealerOptions = await dataApi.selection(dealer);//经销商
  // 经理部下拉处理
  this.regionOptions = this.regionOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.regionOptions = [{
    value: '',
    label: '全部'
  }].concat(this.regionOptions);

  // // 经销商下拉处理
  // this.dealerOptions = this.dealerOptions.data.map(v => {
  //   return {
  //     label: v.deptName,
  //     value: v.deptId
  //   }
  // })
  // this.dealerOptions = [{
  //   value: '',
  //   label: '全部'
  // }].concat(this.dealerOptions);
  this.loadSearchOption({
    // dealerId: this.dealerOptions,
    deptId: this.regionOptions,
  })
}

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

const popConfig = fac.makePopConfig(["password", "merchantsAuthorization", "finishResult"]);

export default {
  mixins: [GridMixin],
  authorize: {
    // addRow: "ADD",
    // updateRow: 'UPDATE',
    // delRow: 'DELETE',
    // importMethod:'IMPORT',
    // exportMethod:'EXPORT',
  },
  components: {//, finishResult, dealerFinishResult,
    detailForm,
    //新增的开始
    // Tree
    //  新增的结束
  },
  watch: {},
  mounted() {
    //  新增的
    this.init()
    //  新增的结束
    if (this.columns[13].field === 'qyFinishNum') {
      this.columns.splice(13, 1)
      this.columns.splice(13, 1)
      this.columns.splice(13, 1)
      this.columns.splice(13, 1)
      this.columns.splice(13, 1)
      this.columns.splice(13, 1)
    }
  },
  computed: {},
  data() {
    const vm = this;
    return {
      //  新增的
      regionId: '', dealerId: '', deptId: '', receiveDeptId: '', userId: '',
      //角色树
      autoExpandParent: false,
      defaultExpandedKeys: [],
      selectedKeys: [],
      expandedKeys: [],
      checkedKeys: [],
      deptList: [],
      treeData: [],
      selectedUser: [],
      treeSpin: false,
      showLeft: false,
      type: 'dept',
      //  新增的结束
      navSwitch: 0,
      popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      userIdList: [],
      strainOptions: [],
      finish: true,
      showTransferPop: false,
      dealerProp: false,
      transferIdArr: '',
      navFlag: 0,
      index: 0,
      issuedId: '',
      title: "大客户拜访记录详情",
      deptOrUser: 0,
      disabledDetail: false,
      planId: '',
      strainIdId: '',
      exportUrl: api.visit.MAIN+'?',
      createTypeFlag: '',
      exportConfig: {
        remote: true,
        beforeExportMethod({options}) {
          console.log('beforeExportMethod>>>>>>>>>>>>>>>>>>>>:', localStorage.getItem('queryParams'))
          // console.log(options)
          // console.log(vm)
          // options.planMold = 1;
          // options.createType = vm.createTypeFlag;
          return options
        },
        exportMethod({options}) {
          return vm.exportMethod({
            options
          })
        },
        types: ['xlsx'],
        modes: ['current', 'selected', 'all']
      },
      regionOptions: []
    };
  },
  methods: {
    loadBaseData,
    addRow() {
      this.index = 0;
      this.title = "大客户拜访记录详情"
      this.disabledDetail = false;
      this.openEdit(0);
    },
    /*下发*/
    issuedPlan(row) {
      console.log(row);
      this.index = 1;
      this.planId = row.planId;
      this.strainIdId = row.strainType
      this.disabledDetail = true;
      this.title = '下发活动计划'
      this.editRow(row)
    },
    //查看
    checkData(row) {
      if (this.navSwitch === 0) {
        this.issuedId = row.planId;
        this.showTransferPop = true;
        this.deptOrUser = this.navFlag;
      } else if (this.navSwitch === 1) {
        this.dealerProp = true
        this.issuedId = row.planId;
        this.deptOrUser = this.navFlag;
      }
      console.log(row)
    },
    qurryDeta(row) {
      this.$router.push({
        path: `visitDetail/${row.id}`
      })
    },
    editData(row) {
      console.log(row)
      this.index = 2;
      this.planId = row.planId;
      this.title = "大客户拜访记录详情"
      this.disabledDetail = false;
      this.editRow(row)
    },
    // updateRow({row}) {
    //   this.index = 2;
    //   this.planId = row.planId;
    //   this.title = "大客户拜访记录详情"
    //   this.disabledDetail = false;
    //   this.editRow(row)
    // },
    closeTransfer() {
      this.showTransferPop = false;
    },
    //关闭弹窗
    closeTransferPop() {
      if (this.navSwitch === 0) {
        this.showTransferPop = false;
      } else if (this.navSwitch === 1) {
        this.dealerProp = false;
      }
      this.refresh();
    },
    deleteTableRow(row) {
      console.log(row)
      dataApi.deleteItem(row.planId).then(res => {
        if (res.code === 200) {
          this.refresh();
        }
      });
    },
    //  新增的
    init() {
      // dataApi.popSelect().then(res => {
      //   this.treeData = XEUtils.toArrayTree(res.data, {
      //     parentKey: 'parentId',
      //     key: 'deptId',
      //     children: 'children'
      //   })
      // })
    },
    handleChange() {
      this.closeAll()
      this.init()
    },
    closeAll() {
      this.checkedKeys = []
      // this.userId = ''
      this.regionId = ''
      this.dealerId = ''
      this.deptId = ''
      this.receiveDeptId = ''
      XEUtils.mapTree(this.treeData, item => {
        if (item.userList) {
          item.userList.map(user => {
            user.checked = false
          })
        }
        return item
      })
      this.selectedUser = []
      this.$nextTick(() => {
        this.refresh()
      })
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys, {checkedNodes}) {
      this.selectedKeys = selectedKeys
      let regionId = [], dealerId = [], deptId = []//三个数组
      checkedNodes.forEach(item => {//对象里的每一个
        if (item.data.props.isDealer === 1) {
          dealerId.push(item.key)
        } else if (item.data.props.isRegion === 1) {
          regionId.push(item.key)
        } else {
          deptId.push(item.key)
        }
      })

      var newArr = regionId.concat(dealerId).concat(deptId)
      this.receiveDeptId = newArr.toString()
      // this.regionId = regionId.toString()
      // this.dealerId = dealerId.toString()
      // this.deptId = deptId.toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },
    checkedUser(user) {
      if (user.checked) {
        this.selectedUser.push(user)
      } else {
        this.selectedUser = this.selectedUser.filter(item => item.userId !== user.userId)
      }
      this.userId = this.selectedUser.map(item => {
        return item.userId
      }).toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },

    //  新增的结束
  },
};
</script>

<style lang="less" scoped>
.status_box {
  float: left;
  margin: 0 30px 12px 0;
  position: relative;
  top: -6px;

  .status_item {
    width: 120px;
    text-align: center;
    font-size: 15px;
    color: #333;
    line-height: 38px;
    display: inline-block;
    background-color: #E9F5FC;
    cursor: pointer;

    &.active {
      background-color: #D90B18;
      color: #fff;
    }
  }
}

.btns_box {
  float: right;
  margin-left: 30px;
  margin-top: 5px;
}

/deep/ .vxe-toolbar {
  height: 70px;
}

//新增的开始
/deep/ .ant-radio-group {
  display: flex;
  width: 100%;

  .ant-radio-wrapper {
    flex: 1;
  }

  .item {
    margin: 16px 0;
  }
}

.left_tree {
  width: 260px;
  float: left;
  padding: 20px;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}

.right_table {
  width: calc(100% - 260px);
  float: right;
  height: 100%;
  position: relative;

  .close {
    position: absolute;
    top: 50%;
    left: -18px;
    display: block;
    z-index: 1000;
    font-size: 36px;
    cursor: pointer;
    color: #fff;
    background-color: #bbb;
    border-radius: 18px;
  }
}

.showLeft {
  width: 100%;
}

//新增的结束
</style>
